/* eslint-disable react/no-danger */
import { Grid, GridItem, Icon } from '@bwoty-web/ui-kit';
import { ICON_UI_SEARCH, ICON_UI_MENU } from '@bwoty-web/ui-kit/icons';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import cx from 'classnames';
import Menu from './components/menu/Menu';
import LogoutPanel from './components/loggedInPanel/globetrotter/LogoutPanel';
import GlobeSearch from './components/search/globetrotter/GlobeSearch';
import SkipLinks from './components/skipLinks/SkipLinks';
import './headerGlobetrotter.scss';
import Logotype from './components/logotype/Logotype';

const HeaderGlobetrotter = ({ membershipGivenName }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const { content, hideNavigation, showLogoutPanel } = useGlobals();
  return (
    <Grid
      className={cx('header', {
        'header--no-navigation': hideNavigation,
        'header--search-open': searchOpen,
      })}
      root
    >
      <GridItem>
        <SkipLinks label={content?.skipLinksLabel} />
        <div className="header-top-container" id="globe-header-top-container">
          <div className="header-top-container__left">
            <button
              type="button"
              aria-expanded={menuOpen}
              aria-haspopup="dialog"
              onClick={() => setMenuOpen(true)}
              className="header-menu-button"
            >
              <Icon path={ICON_UI_MENU} size="s" />
              <span className="visually-hidden">{content?.menuLabel}</span>
            </button>
            {content?.searchLink && (
              <>
                <button
                  type="button"
                  className="header-search-button"
                  aria-expanded={searchOpen}
                  onClick={() => setSearchOpen(true)}
                >
                  <Icon path={ICON_UI_SEARCH} size="s" />
                  <span className="visually-hidden">
                    {content?.searchLink?.href?.name}
                  </span>
                </button>
                <GlobeSearch
                  onClose={() => setSearchOpen(false)}
                  isOpen={searchOpen}
                />
              </>
            )}
          </div>
          <div className="header-logo-container">
            <Logotype />
          </div>
          <div className="header-top-container__right">
            <a
              className="uikit-font-button"
              href={content.conciergeLink.href.url}
            >
              {content.conciergeLink.title}
            </a>
            <a
              className="uikit-font-button"
              href={content.bookingLink.href.url}
            >
              {content.bookingLink.title}
            </a>
          </div>
        </div>
        <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        {showLogoutPanel && (
          <LogoutPanel
            membershipGivenName={membershipGivenName}
            logoutPanelCollection={content?.logoutPanelCollection}
          />
        )}
      </GridItem>
    </Grid>
  );
};

HeaderGlobetrotter.propTypes = {
  membershipGivenName: PropTypes.string,
};

HeaderGlobetrotter.defaultProps = {
  membershipGivenName: '',
};
export default HeaderGlobetrotter;
